/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusCreatePrivacyPolicyDto } from '../../models/lexplus-create-privacy-policy-dto';
import { LexplusPrivacyPolicyDetailDto } from '../../models/lexplus-privacy-policy-detail-dto';

export interface PrivacyPolicyControllerCreateV1$Params {
      body: LexplusCreatePrivacyPolicyDto
}

export function privacyPolicyControllerCreateV1(http: HttpClient, rootUrl: string, params: PrivacyPolicyControllerCreateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusPrivacyPolicyDetailDto>> {
  const rb = new RequestBuilder(rootUrl, privacyPolicyControllerCreateV1.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusPrivacyPolicyDetailDto>;
    })
  );
}

privacyPolicyControllerCreateV1.PATH = '/v1/privacy-policies';
